export default __webpack_public_path__ + "static/media/smartDialogueFinalist.c66906ee.pdf";